export const fundsSourceList = [
    {
        description: 'fundsSourceList.jobIncome',
        label: 'fundsSourceList.jobIncome',
        type: 'fundsSourceList',
        value: '1'
    },
    {
        description: 'fundsSourceList.heritage',
        label: 'fundsSourceList.heritage',
        type: 'fundsSourceList',
        value: '2'
    },
    {
        description: 'fundsSourceList.savingsInvestment',
        label: 'fundsSourceList.savingsInvestment',
        type: 'fundsSourceList',
        value: '3'
    },
    {
        description: 'fundsSourceList.other',
        label: 'fundsSourceList.other',
        type: 'fundsSourceList',
        value: '4'
    }
];

export default fundsSourceList;